import React, { useState } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import howitworks from "../../../assets/img/howitwork2.svg";
import Renovationprocess from "../../../assets/images/Renovationprocess.svg";
import Savetime from "../../../assets/images/Savetime.svg";
import Hand from "../../../assets/images/Hand.svg";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const HowItWork = () => {
  const navigate = useNavigate();
  const [showVideo, setShowVideo] = React.useState(false);
  const [activeCard, setActiveCard] = useState(0);

  useEffect(() => {
    setTimeout(() => setShowVideo(true), 1000);
    window.scrollTo(0, 0);
  }, []);

  const steps = [
    {
      number: 1,
      title: "Measure & Post Your Project",
      description:
        "Use your phone’s camera to scan and measure your space, add details, and submit your project. No need to schedule in-home estimates.",
    },
    {
      number: 2,
      title: "Compare Bids & Select the Best Fit",
      description:
        "Professionals submit bids with pricing, ratings, and reviews. Compare your options, and choose the right pro—no pressure, no surprises.",
    },
    {
      number: 3,
      title: "Lock It In & Get Started",
      description:
        "Secure your project with built-in contracts and payment options. Work begins on your schedule with total transparency.",
    },
  ];

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <div className="how_it_work_sections padding_top">
        <div className="custom_container position-relative">
          <div className="howitworks_img_wrapper">
            <img
              src={howitworks}
              alt="howitworks"
              className="howitworks_img"
              loading="lazy"
            />
          </div>
          <div className="card_revonate_simplified shadow-lg vet_professional">
            <h1 className="fw-bold mb-3 renovate_text_head">
              Your Renovation, Simplified.
            </h1>
            <p className="mb-0 card_text">
              "No sales calls. No hassle. Just fast, transparent, and
              professional bids—right from your phone."
            </p>
            <div className="btn_flex">
              <div>
                <Button
                  style={{ width: "150px" }}
                  className="how-it-works-btn me-2"
                  variant="secondary"
                  onClick={() =>
                    navigate("/select-role", { state: { clickBy: "Client" } })
                  }
                >
                  Post a Project{" "}
                </Button>
              </div>
              <div>
                <Button
                  className="how-it-works-btn-2 me-2"
                  variant="secondary"
                  onClick={() =>
                    navigate("/select-role", {
                      state: { clickBy: "Professional" },
                    })
                  }
                >
                  Sign Up as a Professional{" "}
                </Button>
              </div>
            </div>
          </div>
        </div>

        {showVideo && (
          <>
            <div className="custom_container">
              <div className="vet_professional sec_secound_top_margin">
                <Row className="justify-content mt-4 mt-sm-5">
                  <Col md={12}>
                    <h5>HOW IT WORKS</h5>
                    <h3 className="fw-bold mt-3">
                      SimpleRenovate is free and simple to use
                    </h3>

                    <video
                      width="100%"
                      height="auto"
                      autoPlay
                      muted
                      loop
                      controls
                      playsInline
                      preload="none"
                    >
                      <source
                        src="https://simplerenovate.s3.us-east-1.amazonaws.com/1762134335339howitoworksimplerenovate.mp4"
                        type="video/mp4"
                      />
                    </video>

                    <p className="mt-2 text-center" style={{ color: "#000" }}>
                      <em>
                        Watch how SimpleRenovate makes renovations easy for both
                        clients and professionals.
                      </em>
                    </p>
                  </Col>
                </Row>

                <div className="mt-4 mt-md-5 ">
                  <h5>HOW IT WORKS</h5>
                  <h3 className="fw-bold mt-3 mb-2 mb-md-3">
                    How It Works in 3 Simple Steps
                  </h3>
                  <Row className="justify-content-center mt-4 pb-0 pb-sm-2 pb-md-3 pb-lg-4 pb-xl-5">
                    {steps.map((step, index) => (
                      <Col md={4} key={index} className="mb-4">
                        <Card className="card_vet_professional">
                          <div>
                            <h1
                              className=""
                              style={{
                                fontWeight: "bold",
                                fontSize: "4rem",
                                background:
                                  "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                              }}
                            >
                              {step.number}
                            </h1>
                          </div>
                          <div className="card_body">
                            <h5
                              className="fw-bold  mb-3 mt-0"
                              style={{ textTransform: "none" }}
                            >
                              {step.title}
                            </h5>
                            <p
                              style={{
                                fontWeight: "400",
                                fontSize: "1rem",
                                color: "#333",
                              }}
                            >
                              {step.description}
                            </p>
                          </div>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </div>
                <Col md={12} className="mt-3 mt-md-4">
                  <h5 className="pt-0 pt-sm-2 pt-md-3 pt-lg-5">
                    WE’RE UNIQUELY COMMITTED TO YOUR RENOVATION’S SUCCESS.
                  </h5>
                  <h3 className="fw-bold mt-3 mb-2">
                    Why Choose SimpleRenovate
                  </h3>
                </Col>

                <Row className="justify-content-center mt-3 mt-sm-4">
                  <Col sm={6} md={4} className="mb-2 mb-md-4">
                    <Card className="card_vet_professional card_vet_professional_2">
                      <div className="mb-3" style={{ width: "100%" }}>
                        <img
                          src={Renovationprocess}
                          alt="Smart Technology Icon"
                        />
                      </div>

                      <div>
                        <h6
                          className="fw-bold "
                          style={{ marginBottom: "8px" }}
                        >
                          No Sales Calls{" "}
                        </h6>
                        <p
                          className="mb-0"
                          style={{ fontSize: "0.95rem", lineHeight: "1.4" }}
                        >
                          Avoid pushy pitches and get transparent bids
                          <br /> on your terms.
                        </p>
                      </div>
                    </Card>
                  </Col>

                  <Col sm={6} md={4} className="mb-2 mb-md-4">
                    <Card className="card_vet_professional card_vet_professional_2">
                      <div className="mb-3" style={{ width: "100%" }}>
                        <img src={Hand} alt="Smart Technology Icon" />
                      </div>

                      <div>
                        <h6
                          className="fw-bold "
                          style={{ marginBottom: "8px" }}
                        >
                          Smart Measurements{" "}
                        </h6>
                        <p
                          className="mb-0"
                          style={{ fontSize: "0.95rem", lineHeight: "1.4" }}
                        >
                          Use advanced camera scanning to size up your
                          <br /> project instantly.
                        </p>
                      </div>
                    </Card>
                  </Col>

                  <Col sm={6} md={4} className="mb-2 mb-md-4">
                    <Card className="card_vet_professional card_vet_professional_2">
                      <div className="mb-3" style={{ width: "100%" }}>
                        <img src={Savetime} alt="Smart Technology Icon" />
                      </div>
                      <div>
                        <h6
                          className="fw-bold "
                          style={{ marginBottom: "8px" }}
                        >
                          100% Virtual Bidding{" "}
                        </h6>
                        <p
                          className="mb-0"
                          style={{ fontSize: "0.95rem", lineHeight: "1.4" }}
                        >
                          Get competitive quotes without in-person
                          <br /> estimates.
                        </p>
                      </div>
                    </Card>
                  </Col>

                  <Col md={2} className="mb-0 mb-md-4 d-none"></Col>

                  <Col sm={6} md={4} className="mb-2 mb-md-4">
                    <Card className="card_vet_professional card_vet_professional_2">
                      <div className="mb-3" style={{ width: "100%" }}>
                        <img src={Hand} alt="Hand" />
                      </div>
                      <div>
                        <h6
                          className="fw-bold "
                          style={{ marginBottom: "8px" }}
                        >
                          Built-In Contracts{" "}
                        </h6>
                        <p
                          className="mb-0"
                          style={{ fontSize: "0.95rem", lineHeight: "1.4" }}
                        >
                          Secure, clear agreements for total peace
                          <br /> of mind.
                        </p>
                      </div>
                    </Card>
                  </Col>

                  <Col sm={6} md={4} className="mb-2 mb-md-4">
                    <Card className="card_vet_professional card_vet_professional_2">
                      <div className="mb-3" style={{ width: "100%" }}>
                        <img src={Savetime} alt="Smart Technology Icon" />
                      </div>
                      <div>
                        <h6
                          className="fw-bold "
                          style={{ marginBottom: "8px" }}
                        >
                          Easy Payments{" "}
                        </h6>
                        <p
                          className="mb-0"
                          style={{ fontSize: "0.95rem", lineHeight: "1.4" }}
                        >
                          Pay securely in-app or directly to your
                          <br /> professional.
                        </p>
                      </div>
                    </Card>
                  </Col>

                  <Col md={2} className="mb-0 mb-md-4 d-none"></Col>
                </Row>
              </div>
            </div>
            <div className="how_it_work_footer mt-5">
              <div className="custom_container">
                <h1>Ready to get started?</h1>
                <p className="mt-2">
                  Post your project today and get bids from top professionals!
                </p>
                <div className="d-flex align-items-center align-items-sm-start">
                  <button
                    className="how-it-works-btn tme-1"
                    variant="secondary"
                    style={{ fontWeight: "500" }}
                    onClick={() => {
                      handleViewDetails();
                      navigate("/select-role", {
                        state: { clickBy: "Client" },
                      });
                    }}
                  >
                    Post a Project
                  </button>
                  <button
                    className="how-it-works-btn tme-2"
                    variant="secondary"
                    style={{ fontWeight: "500" }}
                    onClick={() => {
                      handleViewDetails();
                      navigate("/select-role", {
                        state: { clickBy: "Professional" },
                      });
                    }}
                  >
                    Sign up as Professional
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default HowItWork;
